import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { CalculationType } from 'src/app/Modules/informate/enums/calculation-type.enum';
import { ProcessInfoModel } from 'src/app/Modules/informate/models';
import { PipeSpecs, pipeSpecVersion } from 'src/app/Modules/settings/models/idms/pipe-specification.model';
import { UserUtilityService } from 'src/app/services';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';

@Component({
    selector: 'app-pipe-specification-code',
    templateUrl: './pipe-specification-code.component.html',
    styleUrls: ['./pipe-specification-code.component.scss'],
    standalone: false
})
export class PipeSpecificationCodeComponent implements OnInit {
    @Input() pipeSpec: PipeSpecs;
    @Input() calculationType: CalculationType;
    @Output() CopyClick = new EventEmitter<any>();
    @Output() deleteClick = new EventEmitter<any>();
    @ViewChild(MatAccordion) accordion: MatAccordion;
    openedVersion: pipeSpecVersion;
    tooltip_position = 'above';
    processInfoInput: ProcessInfoModel;
    public EditPipeCodes: boolean;
    createPipeCodes: boolean;
    deletePipeCodes: boolean;
    constructor(
        private globalEmmiterService: GlobalEmittersService,
        private user_utility: UserUtilityService
    ) {}

    async ngOnInit(): Promise<void> {
        this.EditPipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Edit);
        this.createPipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Create);
        this.deletePipeCodes = await this.user_utility.checkUserPermissionDataAndRoute('settings-iDMS-pipeCodes', userActions.Delete);
        this.pipeSpec?.versions?.sort((a, b) => b.version - a.version);
        this.globalEmmiterService.refreshpipespec.subscribe((resp) => {
            if (resp) {
                this.accordion?.closeAll();
            }
        });
    }

    copyClicked(event: Event) {
        event.stopPropagation();
        this.CopyClick.emit(true);
    }
    deleteClicked(event: Event) {
        event.stopPropagation();
        this.deleteClick.emit(true);
    }
    processInfoInputDataHandler(processInfo: ProcessInfoModel) {
        this.processInfoInput = processInfo;
    }

    panelOpened(event, item) {
        if (event == true) {
            this.openedVersion = item;
        }
    }
}
